import { makeStyles } from '@material-ui/core/styles';
import { CustomPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles({
  greenDot: {
    height: '5px',
    width: '5px',
    borderRadius: '50%',
    display: 'inline-block',
    backgroundColor: '#2AAB3F',
  },
  assignedBackGrid: {
    '& h6': {
      paddingRight: (props: { portrait: boolean }) => (props.portrait ? 30 : 50),
      fontWeight: '400',
      fontSize: '12px',
      letterSpacing: '0.4px',
      maxWidth: (props: { portrait: boolean }) => (props.portrait ? 190 : 260),
      textAlign: 'right',
      lineHeight: '1.25',
    },
  },
  locationStyle: {
    color: 'rgba(255, 255, 255, .38)',
  },
  divider: {
    width: '98%',
    marginLeft: '16px',
    marginRight: '16px',
  },
  messageIcon: {
    verticalAlign: 'text-bottom',
    marginLeft: 16,
  },
  inline: {
    display: 'inline',
  },
  inlineBlock: {
    display: 'inline-block',
  },
  outerCard: {
    padding: 16,
    paddingTop: '0px',
  },
  pointer: {
    cursor: 'pointer',
    paddingRight: '20px',
  },
  pointer1: {
    cursor: 'pointer',
    paddingRight: '10px',
  },
  tooltipTextColor: {
    color: 'rgba(255, 255, 255, 0.87)',
  },
  assignButtonGrid: {
    '& .assignButton': {
      inlineSize: 'fit-content',
      height: '32px',
      whiteSpace: 'nowrap',
      letterSpacing: '1.25px',
      alignSelf: 'self-end',
      marginRight: '20px',
    },
  },

  updateBtnGrid: {
    '& .updateBtn': {
      inlineSize: 'fit-content',
      height: '32px',
      letterSpacing: '1.25px',
      whiteSpace: 'nowrap',
      alignSelf: 'self-end',
    },
  },
  paper: {
    maxWidth: '170px',
    minWidth: '170px',
    overflow: 'hidden',
    marginLeft: '-35px',
    marginTop: '5px',
    backgroundColor: CustomPalette.elevation.dp24Solid,
  },
  button: {
    padding: '8px',
    paddingLeft: '15px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.09)',
    },
  },
  deleteTaskOnInspection: {
    marginRight: 16,
  },
  reAssignGrid: {
    justifyContent: 'center',
  },
  trashIcon: {
    display: 'block',
    paddingTop: '22px',
  },
  trashIconRemoval: {
    display: 'none',
  },
  inspectionDetails: {
    paddingRight: '30px',
    paddingTop: '15px',
    '& > p': {
      margin: '0px 12px 4px 12px',
    },
    '& > h6 > p': {
      margin: '0px 12px ',
      verticalAlign: 'middle ',
    },
  },
  statusAndButtons: {
    paddingTop: '15px',
  },
  reAssignButtonForFI: {
    paddingLeft: '20px',
    '& .reAssignButton': {
      inlineSize: 'fit-content',
      height: '32px',
      whiteSpace: 'nowrap',
      letterSpacing: '1.25px',
      alignSelf: 'self-end',
      marginRight: '10px',
    },
  },
  checkbox: {
    paddingTop: '10px',
  },
  taskCheckbox: {
    paddingTop: '7px',
  },
  grid1: {
    display: 'inline-flex',
  },
  accordionOuterGrid: {
    '& .taskOuterGridSelected': {
      padding: 16,
      paddingTop: '0px',
      margin: '8px 0px',
      backgroundColor: 'rgba(42, 171, 63, 0.12)',
    },
    '& .taskOuterGrid': {
      padding: 16,
      paddingTop: '0px',
      margin: '8px 0px',
    },
  },
  outerGrid: {
    '& .outerCardSelected': {
      padding: 16,
      paddingTop: '0px',
      backgroundColor: 'rgba(42, 171, 63, 0.12)',
    },
  },
  cardOuterGrid: {
    '& .cardCollapsedBG': {
      backgroundColor: 'rgba(42, 171, 63, 0.12)',
    },
  },
});

export default useStyles;
